import React, { useCallback } from 'react';
import { Box, Divider, FormControlLabel, Grid, IconButton, Stack, Switch } from '@mui/material';
import DocumentOptions from './DocumentOptions';
import SpecializationOptions from './SpecializationOptions';
import { HookFormTextField, MyButton } from '../../common/components';
import { gridSpacing } from '../../../common/themes/constants';
import { IconX } from '@tabler/icons';
import { useFieldArray } from 'react-hook-form';
import CreateOptionalDocumentForm, {
  initialValues as createOptionalDocumentInitialValues
} from '../../clinics/Management/CreateProvider/CreateOptionalDocumentForm';
import { isEmpty } from 'lodash';
import ProviderTitleOptions from '../AddUser/ProviderTitleOptions';

export default function UpdateProviderForm({
  control,
  errors,
  prefix = null,
  setValue,
  trigger,
  getValues,
  isDefault = false,
}) {
  const {
    fields: fieldsOptionalDocument,
    append: appendOptionalDocument,
    remove: removeOptionalDocument,
  } = useFieldArray({
    control,
    name: !isEmpty(prefix) ? prefix + '.optional_documents' : 'optional_documents',
  });

  const handleChange = useCallback(
    (value) => {
      setValue('can_receive', value);
      trigger('can_receive');
    },
    [setValue, trigger]
  );

  return (
    <Grid container spacing={gridSpacing}>
      {!isDefault && (
        <>
          <Grid item sm={12} xs={12}>
            <ProviderTitleOptions prefix={prefix} control={control} errors={errors} />
          </Grid>
          <Grid item sm={6} xs={12}>
            <HookFormTextField
              id="firstname"
              name="firstname"
              placeholder="Enter First name"
              label="First name *"
              schema="firstname"
              prefix={prefix}
              control={control}
              errors={errors}
              autoFocus
              fullWidth
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <HookFormTextField
              id="lastname"
              name="lastname"
              placeholder="Enter Last name"
              label="Last name *"
              schema="lastname"
              prefix={prefix}
              control={control}
              errors={errors}
              fullWidth
            />
          </Grid>
        </>
      )}

      {isDefault && (
        <Grid item xs={12}>
          <HookFormTextField
            id="firstname"
            name="firstname"
            placeholder="Enter Default Provider Name"
            label="Default Provider Name *"
            schema="firstname"
            prefix={prefix}
            control={control}
            errors={errors}
            autoFocus
            fullWidth
          />
        </Grid>
      )}

      <Grid item sm={12} xs={12}>
        <FormControlLabel
          key={`control.can_receive`}
          control={
            <Switch
              checked={getValues('can_receive')}
              key={`switch.can_receive`}
              onChange={(event) => handleChange(event.target.checked)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
          label={'Can Receive Referral'}
        />
      </Grid>

      <Grid item sm={12} xs={12}>
        <SpecializationOptions prefix={prefix} control={control} errors={errors} />
      </Grid>

      <Grid item xs={12}>
        <DocumentOptions
          prefix={prefix}
          control={control}
          errors={errors}
          skip="misc"
          schema="required_documents"
          placeholder="Enter the required referral documents below"
          label="Required Documents *"
        />
      </Grid>

      <Grid item xs={12}>
        <Stack direction="column">
          {fieldsOptionalDocument.map((_item, index) => (
            <Box key={`box-doc-${index}`}>
              <Stack
                key={`stack-users-${index}`}
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{ pt: 2 }}
                style={{ marginBottom: '15px' }}
              >
                <CreateOptionalDocumentForm
                  key={`optional_documents.${index}`}
                  name={`optional_documents.${index}`}
                  prefix={
                    !isEmpty(prefix)
                      ? `${prefix}.optional_documents.${index}`
                      : `optional_documents.${index}`
                  }
                  control={control}
                  errors={errors}
                />
                <IconButton
                  color="gray"
                  onClick={() => {
                    removeOptionalDocument(index);
                  }}
                >
                  <IconX />
                </IconButton>
              </Stack>
              <Divider key={`divider.optional_documents.${index}`} sx={{ my: 1.5 }} />
            </Box>
          ))}
        </Stack>
      </Grid>

      <Grid item xs={12}>
        <MyButton
          type="button"
          variant="contained"
          style={{ width: '200px' }}
          onClick={() => {
            appendOptionalDocument({ ...createOptionalDocumentInitialValues });
          }}
          fullWidth={false}
        >
          Add Optional Document
        </MyButton>
      </Grid>
    </Grid>
  );
}
